module.exports = __webpack_public_path__ + "static/img/tousujianyi.247e2fb4.png";